import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import FilterPanelWidget from '../../moreCore/UI/FilterPanel/FilterPanel';
import "../../moreCore/UI/FilterPanel/FilterPanel";
import template from './_template.html?raw';

import "../FinderBase/FinderBaseTypes";
import FilterPanelOption from '../../moreCore/UI/FilterPanel/FilterPanelOption';
import { isArray } from "dojo/_base/lang";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { FilterPanelTypes, FilterPanelFormat, FilterOptionTypes } from "../../moreCore/UI/FilterPanel/FilterPanelTypes";
import { FinderTypes } from "../FinderBase/FinderBaseTypes";

class FinderBase extends compose(_WidgetBaseSP, _TabEnabledMixin) {
    templateString: any = template;

    // must-have attach-points in the template------------------------------ start
    protected filterPanelContainer: HTMLDivElement;
    protected sectionResult: HTMLDivElement;
    protected resultMessageErrorContainer: HTMLElement;
    protected resultMessageError: HTMLElement;
    protected resultContainer: HTMLElement;
    protected btnSubmitLabel: HTMLElement;
    protected btnSubmit: HTMLElement;
    protected btnContinue: HTMLElement;
    protected btnContinueLabel: HTMLElement;
    protected btnNew: HTMLElement;

    // must-have attach-points in the template ------------------------------ end

    // diverses Paging-Properties; attach-points werden verwendet falls im Template vorhanden
    btnReloadPage: HTMLButtonElement;
    btnNextPage: HTMLButtonElement;
    btnPreviousPage: HTMLButtonElement;
    btnFirstPage: HTMLButtonElement;
    btnLastPage: HTMLButtonElement;
    pagingContainer: HTMLElement;
    secondPagingContainer: HTMLElement;
    resultInfoContainer: HTMLElement;
    protected pagingClassesEnabled: string; // default
    protected pagingClassesDisabled: string; // default
    protected pagingInfoFormatstring: string = "{2} - {3} / {0}";
    protected classesEnabled: string = "mds-hover-bright accentBG"; // default
    protected classesDisabled: string = "w3-disabled sL3"; // default

    // ---------------------
    
    _currentFilterSettings: string = "";
    _currentFilterSettingsApplied: string = "";
    protected isDirty: boolean = false;
    protected _isRequestActive: boolean = false;

    noResultsErrorMessage_part: string = "no entities"; //will be searched in upper case

    protected isPagingEnabled: boolean = false;
    protected _currentPage: number = -1;

    //protected _nextStartIndex: number = 0;
    //protected _currentStartIndex: number = 0;
    protected _maxResultCount: number = 100;
    protected _layouts: Array<StaticTable.Layout> | NestedTableConfig;
    protected selectedLayoutName: string;

    protected lastResponse: more.PackedEntitylistResult<any> = null;/*{
        totalResultCount: 0,
        entitylist: [],
        currentLimit: this._maxResultCount
    };*/

    protected _completeList: Array<any> = [];
    protected primaryKeyAttribute: string = "ID";

    //filterpanels: Array<FilterPanel>;
    filterpanel: MdsLax<InstanceType<typeof FilterPanelWidget>>;

    protected _timeout: number = null;

    protected loadFinderConfigUrl: string = null;
    protected loadFilterDatatUrl: string = null;

    entityListAttributeName: string ;


    btnContinueLabelText: string; // to be replaced with translation in a childclass
    btnSubmitLabelText: string; // to be replaced with translation in a childclass

    //// ----------------------------- Methods ------------------------------------------
    
    loadFinderConfig(): void {

        if (!this.loadFinderConfigUrl) {
            alert("No URL for loadFilterOptions specified!");
            return;
        }

        // mit dem Bypass lädt das Filterpanel ZACK sofort aus dem Localstorage -
        // das Laden passiert trotzdem im Hintergrund, ist halt dann um 1 Zyklus verzögert
        // sollte in der Praxis wurscht sein
        let storedData = localStorage.getItem(location.pathname + "_" + this.id + "_filterOptions");
        let bypassSuccessful: boolean = false;
        if (storedData) {
            try {

                this.bypassFilteroptionsLoading(JSON.parse(storedData));
                bypassSuccessful = true;
            }
            catch (ex) {
                console.warn("stored data for filteroptions invalid", storedData, this.id);
            }
        } 

        if (!bypassSuccessful) {
            this.StandbyStart();
        }


        
        var url = window.appRoot + this.loadFinderConfigUrl;


        this.RequestManager.post(
            url,
            {
                jsonData: null
            },
            lang.hitch(this, this._onLoadFinderConfigResponse, bypassSuccessful),
            lang.hitch(this, this._onLoadFinderConfigError),
            false // sync
        );
    }

    bypassFilteroptionsLoading(data: FinderTypes.FinderOptions) {
        this.applyFinderConfig(data);    
    }

    private _onLoadFinderConfigResponse(isBypassed: boolean, response: FinderTypes.FinderOptions) {

        //console.log("_onLoadFilterOptions Response: ", response)
        localStorage.setItem(location.pathname + "_" + this.id + "_filterOptions", JSON.stringify(response));
        if (isBypassed) {
            
        } else {

            this.StandbyStop();

            this.applyFinderConfig(response);
        }
    }

    private _onLoadFinderConfigError(error: any) {

        this.StandbyStop();

        alert(this.translations["Error__OptionsCantBeLoaded"] + error.Message);
        console.log(this.translations["Error__OptionsCantBeLoaded"] + error.Message);
    }

    protected setMaxResultCount(count: number) {
        this._maxResultCount = count;
        this._checkPagingEnabled();
    }

    protected _checkPagingEnabled() {
        if (this._maxResultCount > 0) {
            this.isPagingEnabled = true;
        } else {
            this.isPagingEnabled = false;
        }
    }

    private applyFinderConfig(data: FinderTypes.FinderOptions) {

        // this.filterPanelContainer_nodeName muss in der Childclass gesetzt werden !
        if (this.filterPanelContainer) {
            this.UiModder.domConstruct.empty(this.filterPanelContainer);
        } else {
            alert("this.filterPanelContainer not defined");
            return;
        }

        if (typeof (data.limit) != "undefined") {
            this.setMaxResultCount(data.limit);
        }

        if (data.tableLayouts) {
           
            //console.debug("finderbase: set table layouts", this._layouts);
            if (isArray(data.tableLayouts)){
                this._layouts = data.tableLayouts;
            }
            else {
                this._layouts = [];
                this._layouts.push(data.tableLayouts);
            }
            if (this._layouts[0]) {
                if (!this.selectedLayoutName || this._getLayoutByName(this.selectedLayoutName) == null) {
                    this.selectedLayoutName = this._layouts[0].name;
                    //console.debug("finderbase: set default selected layout", this.selectedLayoutName);
                }
            }
        }

        this.UiModder.domConstruct.empty(this.filterPanelContainer);

        if (data.sections) {
            let fp = new FilterPanelWidget();
            this.filterpanel = fp;
            on(fp, "submitClick", lang.hitch(this, this._onClick_Submit));

            fp.placeAt(this.filterPanelContainer);
            fp.outputFormat = FilterPanelFormat.compact; // das Format lassen wir jetzt mal fix. data.format == "compact" ? "compact" : "default";

            //fp.setSectionData(data.sections);
            fp.setConfig(data);

            on(this.filterpanel, "serializedData", lang.hitch(this, this.checkDirtyState_delayed));
            on(this.filterpanel, "valueChange", lang.hitch(this, function (dataObj: FilterPanelTypes.ValueChangeNotice) {
                this.checkDirtyState_delayed();
                this._onOptionValueChange(dataObj);
            }));

            this.filterpanel.serializeData();

            // falls man noch was ergänzen möchte (readonly z.B.)
            this.filterOptions_additionalConfig();

            if (data.presetTableLayout) {
                this.selectedLayoutName = data.presetTableLayout;
            }
            if (data.initialLoad === true) {
                this.setPage(0, true);
            }
        } else {
            this.filterpanel = null;
            if (this.filterPanelContainer) {
                this.UiModder.domClass.add(this.filterPanelContainer, "w3-hide");
            }
            this.UiModder.domClass.add(this.btnSubmit, "w3-hide");

            this.checkDirtyState();
        }
    }

    protected _getLayoutByName(name: string): StaticTable.Layout {
        //console.log("this._layouts: ", this._layouts);
        if (this._layouts) {

            if (Array.isArray(this._layouts)) { // das wird bei der BST der Fall sein
                for (var layout of this._layouts) {
                    if (layout.name == name) {
                        return layout;
                    }
                }
            } else {
                console.log("this._layouts is NOT an array, most likely you are using the wrong Layouts Configuration Structure for BST.");
            }
        }

        return null;
    }

    private checkDirtyState_delayed(result: boolean): void {

        // bestehendes Event unterbrechen
        if (this._timeout != null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        this._timeout = setTimeout(lang.hitch(this, this.checkDirtyState, result), 100);
    }

    protected checkDirtyState(bForceState?: boolean): void {

        //console.debug("checkDirtyState");

        if (bForceState === true || bForceState === false) {
            this.set("dirty", bForceState);
                return;
            }

        if (this.filterpanel) {
            let json = { sections: this.filterpanel.getData() };//, currentStartIndex: this._currentStartIndex, limit: this._maxResultCount };
            var bValid = json.sections !== null;

            let jsonString = JSON.stringify(json)
            this._currentFilterSettings = jsonString;
            this.setDirty(this._currentFilterSettingsApplied != this._currentFilterSettings && bValid === true);
        } else {
            this.setDirty(true);
        }
        
    }

    reload(): void {
        this.reloadData();
    }

    reloadData(): void {
        this.getFilterlist(this._currentPage);
    }

    protected setCreateNewCallback(callback: Function) {
        if (typeof (callback) == "function") {
            this._displayNewButton(true, callback)
        } else {

        }
    }

    private _displayNewButton(bShow, callback): void {

        let isCallbackValid = typeof (callback) == "function";

        if (this.isEmbeddedInTab) {
            if (isCallbackValid) {
                this.createDefaultButton("new", callback);
            }

        } else {
            this.UiModder.domClass.toggle(this.btnNew, "w3-hide", !bShow);

            this.UiModder.domClass.toggle(this.btnNew, this.classesDisabled, !isCallbackValid);
            this.UiModder.domClass.toggle(this.btnNew, this.classesEnabled, isCallbackValid);

            if (isCallbackValid) {
                on(this.btnNew, "click", callback);
            }
        }
    }

    private _retryGetFilterlist: boolean = true;
    getFilterlist(pageNo?: number): void {
        
        if (!this.loadFilterDatatUrl) {
            console.log(this.id + ": No URL for getFilterList specified!")
            return;
        }

        if (pageNo) {
            this.setPage(pageNo, true);
            return;
        } 

        if (this.isDirty) {
            this._completeList = [];
        }

        this.UiModder.domClass.remove(this.sectionResult, "w3-hide");


        var url = window.appRoot + this.loadFilterDatatUrl;
        this._isRequestActive = true;
        this.setPagingStyle();

        let data = null;

        if (this.filterpanel) {
            try {
                data = JSON.parse(this._currentFilterSettings);
            } catch (ex) {
                console.warn(this.id + ": invalid filtersettings? cannot parse json, probably race condition.", ex);
                if (this._retryGetFilterlist) {
                    setTimeout(lang.hitch(this, this.getFilterlist, pageNo), 600);
                    this._retryGetFilterlist = false;
                }
                return;
            }

            this._retryGetFilterlist = true;
        } else {
            data = {};
        }
        if (data && this.isPagingEnabled) {
            data.limit = this._maxResultCount;
            data.currentStartIndex = this._getOffsetFromPage(this._currentPage);
        }

        this.StandbyStart(this.sectionResult);


        var stringData = JSON.stringify(data);

        //console.log("GET FILTERLIST DATA::: STR ", stringData)
        //console.log("GET FILTERLIST DATA::: ", data)

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onGetFilterlistResult, this._currentFilterSettings),
            lang.hitch(this, this._onGetFilterlistError, this._currentFilterSettings),
            false // sync
        );
    }

    _onGetFilterlistResult(currentFiltersettings: string, response: any) {

        this.StandbyStop();
        this._isRequestActive = false;
        this._currentFilterSettingsApplied = currentFiltersettings;
        this.checkDirtyState(false);

        this.lastResponse = response;

        this.showError(false);

        this.setPagingStyle();
        this.processFilterListResponse(response);
    }

    _onGetFilterlistError(currentFilterSettings:string ,error: any ): void {

        this.lastResponse = null;

        console.error(error);
        this.StandbyStop();
        this._isRequestActive = false;
        this._currentFilterSettingsApplied = currentFilterSettings;

        if (error.Message) {
            alert(error.Message);
        }

        this.showError(error.Message);
        //alert(error.message);
    }

    //private selectedPageButton = null;
    protected setPagingStyle(): void {

        //console.log("setPagingStyle", this.lastResponse, this.isDirty, this._currentPage);

        let pagesTotal = this._getMaxPagesFromResult();
        let currentPage = this._currentPage;
        let resultIndexThisPage = this._getMinIndexOfPage(currentPage) + 1;
        let resultIndexMaxThisPage = this._getMaxIndexOfPage(currentPage) + 1;

        if (this.isPagingEnabled) {            

            let shownPages: Array<number> = [];

            if (this.pagingContainer) {
                // wenns zu viele gibt: begrenzen auf Start, Ende und ein paar rund um die aktuelle Seite herum
                if (pagesTotal > 15) {
                    shownPages.push(1);
                    shownPages.push(2);
                    shownPages.push(3);

                    for (let x = this._currentPage - 3; x < this._currentPage + 4; x++) {
                        shownPages.push(x);
                    }

                    shownPages.push(pagesTotal - 2);
                    shownPages.push(pagesTotal - 1);
                    shownPages.push(pagesTotal - 0);
                }

                if (this.lastResponse && !this._isRequestActive) {
                    let indexPerPage = 0;

                    let container = this.UiModder.domConstruct.create("div");
                    let secondContainer = null;

                    if (this.secondPagingContainer) {
                        secondContainer = container.cloneNode(true);
                        this.UiModder.domConstruct.place(secondContainer, this.secondPagingContainer);
                    }

                    let insertSpacer: boolean = true;

                    for (let pageNo = 1; pageNo <= pagesTotal; pageNo++) {

                        if (shownPages.indexOf(pageNo, 0) != -1 || shownPages.length == 0) {
                            insertSpacer = true;

                            // button zeichnen:
                            let button = this.UiModder.domConstruct.create("button", {
                                "className": "mds-button-base pagingButton",
                                "innerHTML": pageNo.toString(),
                                "id": "pageBtn-" + pageNo.toString()
                            }, container);


                            if (pageNo == this._currentPage) {
                                this.UiModder.domClass.add(button, "selected");

                            } else {
                                this.UiModder.domClass.add(button, "mds-hover-bright");
                                on(button, "click", lang.hitch(this, this.setPage, pageNo, true));
                            }

                            if (secondContainer) {
                                let bottomButton: HTMLButtonElement = <HTMLButtonElement>button.cloneNode(true);
                                this.UiModder.domConstruct.place(bottomButton, secondContainer);

                                this.UiModder.domAttr.set(bottomButton, "id", "pageBtnSecond-" + pageNo.toString());

                                if (pageNo == this._currentPage) {
                                } else {
                                    on(bottomButton, "click", lang.hitch(this, this.setPage, pageNo, true));
                                }
                            }

                        } else {
                            if (insertSpacer) {
                                insertSpacer = false;

                                let spacer = this.UiModder.domConstruct.create("span", {
                                    "className": "spacer",
                                    "innerHTML": "..."
                                }, container);


                                if (secondContainer) {
                                    let bottomSpacer = spacer.cloneNode(true);
                                    this.UiModder.domConstruct.place(bottomSpacer, secondContainer);
                                }
                            }
                        }
                    }

                    //this.UiModder.domConstruct.empty(this.pagingContainer);
                    this.UiModder.domConstruct.place(container, this.pagingContainer, "only");
                    this.UiModder.domClass.remove(this.pagingContainer, "w3-disabled w3-hide");

                    if (secondContainer) {
                        this.UiModder.domConstruct.place(secondContainer, this.secondPagingContainer, "only");
                        this.UiModder.domClass.remove(this.secondPagingContainer, "w3-disabled w3-hide");
                    }
                }
                else if (this._isRequestActive) {
                    this.UiModder.domClass.add(this.pagingContainer, "w3-disabled");
                    if (this.secondPagingContainer) {
                        this.UiModder.domClass.add(this.secondPagingContainer, "w3-disabled");
                    }
                }
                else {
                    this.UiModder.domConstruct.empty(this.pagingContainer);
                    this.UiModder.domClass.add(this.pagingContainer, "w3-hide");

                    if (this.secondPagingContainer) {
                        this.UiModder.domConstruct.empty(this.secondPagingContainer);
                        this.UiModder.domClass.add(this.secondPagingContainer, "w3-hide");
                    }
                }

            }

           

            //if (this.btnContinue) {
            //    if ((endOfList != true || this.getDirty() == true) && this._isRequestActive != true) {
            //        this.UiModder.domClass.remove(this.btnContinue, this.classesDisabled);
            //        this.UiModder.domClass.add(this.btnContinue, this.classesEnabled);
            //    } else {
            //        this.UiModder.domClass.remove(this.btnContinue, this.classesEnabled);
            //        this.UiModder.domClass.add(this.btnContinue, this.classesDisabled);
            //    }
            //}

        } else {
            this._currentPage = 1;
        }

        if (this.resultInfoContainer) {
            /*
                0 - Gesamtzähler Ergebnisse
                1 - Anzahl gezeigte Ergebnisse
                2 - Gezeigte Ergebnisse ab X
                3 - Gezeigte Ergebnisse bis Y
                4 - Aktuelle "Seite"
                5 - Anzahl "Seiten"

                */
            if (this.lastResponse && !this._isRequestActive) {
                if (this.lastResponse.totalResultCount == 0) {
                    this.resultInfoContainer.innerHTML = this.translations["General__NoEntries"];
                    //    this.stringFormat(this.pagingInfoFormatstring,
                    //    this.lastResponse.totalResultCount.toString(),
                    //    "0",
                    //    "0",
                    //    "0",
                    //    "1",
                    //    "1"
                    //);
                } else {

                    this.resultInfoContainer.innerHTML = this.stringFormat(this.pagingInfoFormatstring,
                        this.lastResponse.totalResultCount.toString(),
                        this._maxResultCount.toString(),
                        resultIndexThisPage.toString(),
                        resultIndexMaxThisPage.toString(),
                        this._currentPage.toString(),
                        pagesTotal.toString()
                    );
                }

                this.UiModder.domClass.remove(this.resultInfoContainer, "w3-disabled w3-hide");
            } else if (this._isRequestActive) {
                this.UiModder.domClass.add(this.resultInfoContainer, "w3-disabled");
            }

        }

        this.setSubmitButtonStyles();

    }

    getFilterOptionByName(optionName: string): MdsLax<InstanceType<typeof FilterPanelOption>> {
        if (this.filterpanel) {
            return this.filterpanel.getFilterOptionByName(optionName);
        }

        return null;
    }

    showError(message: string | false, bKeepResultVisible?: boolean) { // sollte in die viewBase... ist aber gut abgesichert, kann nix passieren
        if (message === false) {
            if (this.resultMessageErrorContainer) this.UiModder.domClass.add(this.resultMessageErrorContainer, "w3-hide");
        } else {
            if (this.resultMessageError) this.UiModder.domAttr.set(this.resultMessageError, "innerHTML", message);
            if (this.resultMessageErrorContainer) this.UiModder.domClass.remove(this.resultMessageErrorContainer, "w3-hide");

            if (bKeepResultVisible !== true) {
                if (this.resultContainer) this.UiModder.domClass.add(this.resultContainer, "w3-hide");
            }
        }
    }

    ///// ----------------- overloads -----------------------------------START

    // falls man die default configuration beim Start noch überschreiben möchte (readonly z.B.)
    filterOptions_additionalConfig(): void {
        // Wird in der Kindklasse überschrieben
    }

    // Evens der Filterpanel-Controls fangen
    protected _onOptionValueChange(dataObj: filterPanel_option_valuechange_obj): void { // interface filterPanel_option_valuechange_obj {name: string; option: string; optionValue: string; toggleSelected: boolean;}
        // wird in der Kindklasse überschrieben
    }

    // handle the Data here
    protected processFilterListResponse(response: any): void {
        // in Kindklasse überschreiben
    }

    setSubmitButtonStyles(): void {

        let endOfList: boolean = false;
        endOfList = this._currentPage >= this._getMaxPagesFromResult();
        
        if (this.btnSubmit) {

            this.UiModder.domClass.remove(this.btnSubmit, this.classesDisabled);
            this.UiModder.domClass.remove(this.btnSubmit, this.classesEnabled);

            let fctDisablingClasses = this.UiModder.domClass.remove;
            let fctEnablingClasses = this.UiModder.domClass.add;

            if (this.getDirty() == true && this._isRequestActive != true) {
                //console.debug("setSubmitButtonStyle ENABLED", this.classesEnabled, endOfList, this.getDirty(), this._isRequestActive);

                
            } else {
                //console.debug("setSubmitButtonStyle DISABLED", this.classesDisabled, endOfList, this.getDirty(), this._isRequestActive);

                fctEnablingClasses = this.UiModder.domClass.remove;
                fctDisablingClasses = this.UiModder.domClass.add;
            }

            fctDisablingClasses(this.btnSubmit, this.classesDisabled);
            fctEnablingClasses(this.btnSubmit, this.classesEnabled);

        } 

        if (this.btnContinue) {
            this.UiModder.domClass.remove(this.btnContinue, this.pagingClassesDisabled);
            this.UiModder.domClass.remove(this.btnContinue, this.pagingClassesEnabled);

            let fctDisablingClasses = this.UiModder.domClass.remove;
            let fctEnablingClasses = this.UiModder.domClass.add;

            if (!endOfList && this._isRequestActive != true) {
                this.UiModder.domClass.remove(this.btnContinue, "w3-hide hide hidden");
            } else {
                this.UiModder.domClass.add(this.btnContinue, "w3-hide hide hidden");
                fctEnablingClasses = this.UiModder.domClass.remove;
                fctDisablingClasses = this.UiModder.domClass.add;
            }

            fctDisablingClasses(this.btnContinue, this.pagingClassesDisabled);
            fctEnablingClasses(this.btnContinue, this.pagingClassesEnabled);
        }

        if (this.btnLastPage) {
            this.UiModder.domClass.remove(this.btnLastPage, this.pagingClassesDisabled);
            this.UiModder.domClass.remove(this.btnLastPage, this.pagingClassesEnabled);

            let fctDisablingClasses = this.UiModder.domClass.remove;
            let fctEnablingClasses = this.UiModder.domClass.add;

            if (!endOfList && this._isRequestActive != true && this.isPagingEnabled) {


            } else {

                fctEnablingClasses = this.UiModder.domClass.remove;
                fctDisablingClasses = this.UiModder.domClass.add;
            }

            fctDisablingClasses(this.btnLastPage, this.classesDisabled);
            fctEnablingClasses(this.btnLastPage, this.classesEnabled);
        }

        if (this.btnNextPage) {
            this.UiModder.domClass.remove(this.btnNextPage, this.pagingClassesDisabled);
            this.UiModder.domClass.remove(this.btnNextPage, this.pagingClassesEnabled);

            let fctDisablingClasses = this.UiModder.domClass.remove;
            let fctEnablingClasses = this.UiModder.domClass.add;

            if (!endOfList && this._isRequestActive != true && this.isPagingEnabled) {


            } else {

                fctEnablingClasses = this.UiModder.domClass.remove;
                fctDisablingClasses = this.UiModder.domClass.add;
            }

            fctDisablingClasses(this.btnNextPage, this.classesDisabled);
            fctEnablingClasses(this.btnNextPage, this.classesEnabled);
        }

        if (this.btnPreviousPage) {
            this.UiModder.domClass.remove(this.btnPreviousPage, this.pagingClassesDisabled);
            this.UiModder.domClass.remove(this.btnPreviousPage, this.pagingClassesEnabled);

            let fctDisablingClasses = this.UiModder.domClass.remove;
            let fctEnablingClasses = this.UiModder.domClass.add;

            if (this._currentPage > 1 && this._isRequestActive != true && this.isPagingEnabled) {


            } else {

                fctEnablingClasses = this.UiModder.domClass.remove;
                fctDisablingClasses = this.UiModder.domClass.add;
            }

            fctDisablingClasses(this.btnPreviousPage, this.pagingClassesDisabled);
            fctEnablingClasses(this.btnPreviousPage, this.pagingClassesEnabled);
        }

        if (this.btnFirstPage) {
            this.UiModder.domClass.remove(this.btnFirstPage, this.pagingClassesDisabled);
            this.UiModder.domClass.remove(this.btnFirstPage, this.pagingClassesEnabled);

            let fctDisablingClasses = this.UiModder.domClass.remove;
            let fctEnablingClasses = this.UiModder.domClass.add;

            if (this._currentPage > 1 && this._isRequestActive != true && this.isPagingEnabled) {


            } else {

                fctEnablingClasses = this.UiModder.domClass.remove;
                fctDisablingClasses = this.UiModder.domClass.add;
            }

            fctDisablingClasses(this.btnFirstPage, this.pagingClassesDisabled);
            fctEnablingClasses(this.btnFirstPage, this.pagingClassesEnabled);
        }
    }

    _onClick_Submit(evt: Event) {
        if (this._isRequestActive === true || !this.isDirty) {
            return;
        }

        this.getFilterlist(1);
    }

    _onClick_Continue(evt: MouseEvent) {
        if (this._isRequestActive === true) return;

        if (this._currentPage < this._getMaxPagesFromResult()) {
            this.setPage(this._currentPage + 1, true);
        }
    }

    _onClick_PreviousPage(evt: MouseEvent) {
        if (this.isPagingEnabled && this._currentPage > 1) {
            this.setPage(this._currentPage - 1, true);
        }
    }
    _onClick_NextPage(evt: MouseEvent) {
        if (this.isPagingEnabled && this._currentPage < this._getMaxPagesFromResult()) {
            this.setPage(this._currentPage + 1, true);
        }
    }

    _onClick_FirstPage(evt: MouseEvent) {
        this.setPage(1, true);
    }

    _onClick_LastPage(evt: MouseEvent) {
        this.setPage(this._getMaxPagesFromResult(), true);
    }

    _onClickReload(evt: MouseEvent) {
        this.getFilterlist(this._currentPage);
    }

    setPage(page: number = 1, loadResults?: boolean) {
        if (!page || page < 1) {
            page = 1;
        }
        if (this.isPagingEnabled) {
            let currentButton = document.getElementById("pageBtn-" + this._currentPage.toString());
            if (currentButton) this.UiModder.domClass.remove(currentButton, "selected mds-hover-dark mds-hover-bright");

            let secondButton = document.getElementById("pageBtnSecond-" + this._currentPage.toString());
            if (secondButton) this.UiModder.domClass.remove(secondButton, "selected mds-hover-dark mds-hover-bright");

            this._currentPage = page;

            currentButton = document.getElementById("pageBtn-" + this._currentPage.toString());
            if (currentButton) this.UiModder.domClass.add(currentButton, "selected mds-hover-bright");

            secondButton = document.getElementById("pageBtnSecond-" + this._currentPage.toString());
            if (secondButton) this.UiModder.domClass.add(secondButton, "selected mds-hover-bright");
        } else {
            this._currentPage = page;
        }

        if (loadResults === true) {
            this.getFilterlist();
        }
    }

    protected _getOffsetFromPage(pageNo: number): number {
        if (!pageNo || pageNo <= 1 || !this.isPagingEnabled) {
            return 0;
        }

        return this._maxResultCount * pageNo - this._maxResultCount;
    }

    private _getPageFromIndex(index: number, totalResultCount?: number): number {
        if (!totalResultCount && this.lastResponse) {
            totalResultCount = this.lastResponse.totalResultCount;
        }

        if (!totalResultCount || totalResultCount == 0) return 0;

        if (!this.isPagingEnabled || this._maxResultCount < 1) {
            return 1;
        }

        let counter = 1;
        let currentIndex = 0;
        while (currentIndex + this._maxResultCount < index) { // zb 0 + 30 = 30, index = 34
            index = index + this._maxResultCount;
            counter++;
        }

        return counter;
    }

    private _getMaxIndexOfPage(pageNo: number, totalResultCount?: number): number {
        if (!totalResultCount && this.lastResponse) {
            totalResultCount = this.lastResponse.totalResultCount;
        }

        if (!pageNo) {
            pageNo = this._currentPage;
        }

        if (!totalResultCount || totalResultCount == 0 || pageNo < 1) return 0;

        if (!this.isPagingEnabled || this._maxResultCount < 1) {
            return totalResultCount - 1;
        }

        let maxPage = this._getMaxPagesFromResult(totalResultCount);
        if (pageNo >= maxPage) {
            return totalResultCount - 1;
        }

        return pageNo * this._maxResultCount - 1;
    }

    private _getMinIndexOfPage(pageNo: number, totalResultCount?: number): number {
        if (!totalResultCount && this.lastResponse) {
            totalResultCount = this.lastResponse.totalResultCount;
        }

        if (!pageNo) {
            pageNo = this._currentPage;
        }

        if (!totalResultCount || totalResultCount == 0) return -1;

        if (!this.isPagingEnabled || this._maxResultCount < 1) {
            return -1;
        } else if (pageNo <= 1) {
            return 0;
        }


        let maxPage = this._getMaxPagesFromResult(totalResultCount);
        if (pageNo > maxPage) {
            return totalResultCount;
        }

        return pageNo * this._maxResultCount - this._maxResultCount;
    }

    private _getMaxPagesFromResult(totalResultCount?: number): number {
        if (!totalResultCount && this.lastResponse) {
            totalResultCount = this.lastResponse.totalResultCount;
        }

        if (!totalResultCount || totalResultCount == 0) return 0;

        if (!this.isPagingEnabled || this._maxResultCount < 1) {
            return 1;
        }

        let counter = 1;
        let index = 0;
        while (index + this._maxResultCount < totalResultCount) {
            index = index + this._maxResultCount;
            counter++;
        }

        return counter;
    }

    ///// ----------------- overloads -----------------------------------END
    /////-------------------getters && setters --------------------------START

    //setBtnContinueLabelText(labelText: string): void {
    //    this.btnContinueLabelText = labelText;
    //}
    //getBtnContinueLabelText(): string {
    //    return this.btnContinueLabelText;
    //}
    //_setBtnContinueLabelTextAttr(labelText: string): void {
    //    this.setBtnContinueLabelText(labelText);
    //}
    //_getBtnContinueLabelTextAttr(): string {
    //    return this.getBtnContinueLabelText();
    //}

    //setBtnSubmitLabelText(labelText: string): void {
    //    this.btnContinueLabelText = labelText;
    //}
    //getBtnSubmitLabelText(): string {
    //    return this.btnContinueLabelText;
    //}
    //_setBtnSubmitLabelTextAttr(labelText: string): void {
    //    this.setBtnContinueLabelText(labelText);
    //}
    //_getBtnSubmitLabelTextAttr(): string {
    //    return this.getBtnContinueLabelText();
    //}

    setClassesEnabled(cssClasses: string): void {
        this.classesEnabled = cssClasses
    }
    getClassesEnabled(): string {
        return this.classesEnabled;
    }
    _setClassesEnabledAttr(cssClasses: string): void {
        this.setClassesEnabled(cssClasses);
    }
    _getClassesEnabledAttr(): string {
        return this.getClassesEnabled();
    }

    setClassesDisabled(cssClasses: string): void {
        this.classesDisabled = cssClasses
    }
    getClassesDisabled(): string {
        return this.classesDisabled;
    }
    _setClassesDisabledAttr(cssClasses: string): void {
        this.setClassesDisabled(cssClasses);
    }
    _getClassesDisabledAttr(): string {
        return this.getClassesDisabled();
    }

    setEntityListAttributeName(name: string): void {
        if (typeof  name == "string")  this.entityListAttributeName = name;
    }
    getEntityListAttributeName(): string {
        return this.entityListAttributeName;
    }
    _getEntityListAttributeNameAttr(): string {
        return this.getEntityListAttributeName();
    }
    _setEntityListAttributeName(name: string): void {
        this.setEntityListAttributeName(name);
    }
    setDirty(value?: boolean): void {
        this.isDirty = value === true;

        if (this.isDirty === true) {
            //this._nextStartIndex = 0;
            if (this.sectionResult && this.filterpanel) {
                this.UiModder.domClass.add(this.sectionResult, "w3-disabled");
                this.setPage(0);
            }
            if (!this.filterpanel) {
                this.setPage(0, true);
            }
        } else {
            if (this.sectionResult) {
                this.UiModder.domClass.remove(this.sectionResult, "w3-disabled");
            }
        }

        this.setSubmitButtonStyles();
    }
    _setDirtyAttr(value?: boolean) {
        this.setDirty(value);
    }
    getDirty(): boolean {
        return this.isDirty;
    }
    _getDirtyAttr(): boolean {
        return this.getDirty();
    }
    //setLoadFilterDatatUrl(url: string): void {
    //    if (url && typeof url == "string" && url.length) {
    //        this.loadFilterDatatUrl = url;
    //    }
    //}
    //getLoadFilterDatatUrl(): string {
    //    return this.loadFilterDatatUrl;
    //}
    //_setLoadFilterDatatUrlAttr(url: string): void {
    //    this.setLoadFilterDatatUrl(url);
    //}
    //_getLoadFilterDatatUrlAttr(): string {
    //    return this.getLoadFilterDatatUrl();
    //}
    //getLoadFilterOptionsUrl(): string {
    //    return this.loadFinderConfigUrl;
    //}
    //setLoadFilterOptionsUrl(url: string): void {
    //    if (url && typeof url == "string" && url.length) {
    //        this.loadFinderConfigUrl = url;
    //    }
    //}
    //_getLoadFilterOptionsUrlAttr(): string {
    //    return this.getLoadFilterOptionsUrl();
    //}
    //_setLoadFilterOptionsUrlAttr(url: string): void {
    //    this.setLoadFilterOptionsUrl(url);
    //}
    /////-------------------getters && setters --------------------------END

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //default stuff
        if (!this.classesEnabled) this.classesEnabled = "accentBG mds-hover-bright"; 
        if (!this.classesDisabled) this.classesDisabled = "w3-disabled tertiaryBG"; 
        if (!this.entityListAttributeName) this.entityListAttributeName = "entitylist"; 
        if (!this.btnContinueLabelText) this.btnContinueLabelText = "Further results"; // to be replaced with translation in a childclass
        if (!this.btnSubmitLabelText) this.btnSubmitLabelText = "Search"; // to be replaced with translation in a childclass

        if (!this.pagingClassesDisabled) this.pagingClassesDisabled = this.classesDisabled;
        if (!this.pagingClassesEnabled) this.pagingClassesEnabled = this.classesEnabled;

        if (this.translations["StaticTable_ResultInfo"]) {
            this.pagingInfoFormatstring = this.translations["StaticTable_ResultInfo"];
        }

    }

    startup(): void {
        super.startup.apply(this, arguments as any);


        if (this.sectionResult) this.UiModder.domClass.add(this.sectionResult, "w3-hide");

        this._checkPagingEnabled();

        if (this.btnReloadPage) {
            on(this.btnReloadPage, "click", lang.hitch(this, this._onClickReload));
        }


        this.loadFinderConfig();
    }
}

export default mdsWidget(FinderBase);
